import React from 'react';
import { Dialog, DialogContent, Box, IconButton, Typography, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useConfirmDialogStore } from '@/store/confirmDialogStore';

export default function ConfirmDialog() {
    const {
        isOpen,
        title,
        message,
        onConfirm,
        onCancel,
        action: { closeConfirmDialog },
    } = useConfirmDialogStore((state) => {
        const { isOpen, title, message, onConfirm, onCancel, action } = state;
        return { isOpen, title, message, onConfirm, onCancel, action };
    });

    const handleConfirm = () => {
        onConfirm();
        closeConfirmDialog();
    };

    const handleCancel = () => {
        onCancel();
        closeConfirmDialog();
    };

    const handleClickClose = () => {
        closeConfirmDialog();
    };

    return (
        <Dialog
            open={isOpen}
            onClose={handleClickClose}
            maxWidth="xs"
            fullWidth
            sx={{
                zIndex: 1500,
                '& .MuiDialog-paper': {
                    borderRadius: '12px !important',
                    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
                },
            }}
        >
            <DialogContent sx={{ p: 0, position: 'relative' }}>
                {/* 닫기 버튼 */}
                <IconButton
                    onClick={handleClickClose}
                    sx={{
                        position: 'absolute',
                        right: 12,
                        top: 12,
                        zIndex: 1,
                        color: '#000',
                    }}
                >
                    <CloseIcon />
                </IconButton>

                <Box sx={{ p: 4, pt: 6 }}>
                    {/* 제목 */}
                    <Box sx={{ textAlign: 'center', mb: 3 }}>
                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 600,
                                fontSize: '28px',
                                color: '#222',
                                mb: 1,
                            }}
                        >
                            {title}
                        </Typography>
                        <Typography
                            sx={{
                                fontSize: '14px',
                                color: '#666',
                                lineHeight: '1.5',
                            }}
                        >
                            {message}
                        </Typography>
                    </Box>

                    {/* 버튼 영역 */}
                    <Box sx={{ display: 'flex', gap: 2 }}>
                        <Button
                            variant="outlined"
                            fullWidth
                            onClick={handleCancel}
                            sx={{
                                borderColor: '#ddd',
                                color: '#666',
                                py: 1.5,
                                fontSize: '16px',
                                fontWeight: 600,
                                borderRadius: '8px',
                                textTransform: 'none',
                                '&:hover': {
                                    borderColor: '#999',
                                    backgroundColor: 'transparent',
                                },
                            }}
                        >
                            취소
                        </Button>
                        <Button
                            onClick={handleConfirm}
                            fullWidth
                            variant="contained"
                            sx={{
                                backgroundColor: '#FF4B6B',
                                color: '#fff',
                                py: 1.5,
                                fontSize: '16px',
                                fontWeight: 600,
                                borderRadius: '8px',
                                textTransform: 'none',
                                '&:hover': {
                                    backgroundColor: '#E03E5A',
                                },
                            }}
                        >
                            확인
                        </Button>
                    </Box>
                </Box>
            </DialogContent>
        </Dialog>
    );
}
